<script setup lang="ts">
const { src = {} as StoryBlokImage, msrc, height, width, mheight, mwidth, fit, justify, link, resolutionScale = 1 } = defineProps<{
  src: StoryBlokImage
  fit?: boolean
  width?: string | number
  height?: string | number
  msrc?: StoryBlokImage
  mwidth?: string | number
  mheight?: string | number
  justify?: string
  noLazy?: boolean
  link?: StoryBlokLink
  resolutionScale?: string | number
}>()
const focus = (src && src.focus) ? `:focal(${src.focus})` : ''
const params = [fit && 'fit-in', `${Number(width) * Number(resolutionScale) || 0}x${Number(height) * Number(resolutionScale) || 0}`]
const desktopSrcset = src.filename?.endsWith('.svg')
  ? src.filename
  : src.filename?.replace('a.storyblok.com', `img2.storyblok.com/${[...params, `filters:format(webp)${focus}`].filter(Boolean).join('/')}`)
const desktopFallback = src.filename?.endsWith('.svg')
  ? src.filename
  : src.filename?.replace('a.storyblok.com', `img2.storyblok.com/${[...params, 'filters:format(png)'].filter(Boolean).join('/')}`)

const mobileSrc = msrc?.filename || src?.filename
const mobileParams = [fit && 'fit-in', `${mwidth || width || 0}x${mheight || height || 0}`]
const mobileSrcset = mobileSrc?.endsWith('.svg')
  ? mobileSrc
  : mobileSrc?.replace('a.storyblok.com', `img2.storyblok.com/${[...mobileParams, 'filters:format(webp)'].filter(Boolean).join('/')}`)
const mobileFallback = mobileSrc?.endsWith('.svg')
  ? mobileSrc
  : mobileSrc?.replace('a.storyblok.com', `img2.storyblok.com/${[...mobileParams, 'filters:format(png)'].filter(Boolean).join('/')}`)
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>

<template>
  <StoryblokLink v-bind="link">
    <picture>
      <source :width="mwidth" :height="mheight" :srcset="mobileSrcset" media="(max-width: 767px)" type="image/webp">
      <source :width="mwidth" :height="mheight" :srcset="mobileFallback" media="(max-width: 767px)">
      <source :width="width" :height="height" :srcset="desktopSrcset" type="image/webp">
      <img
        :width="width"
        :height="height"
        :class="[justify, $attrs.class]"
        :src="desktopFallback"
        :alt="src?.alt"
        :loading="noLazy ? 'eager' : 'lazy'"
      >
    </picture>
  </StoryblokLink>
</template>
